import { lazy } from "react";
export const feature = {
    id: "ab-tests",
    nav: [
        {
            label: "Programmatic",
            icon: "LayoutTemplate",
            path: "/programmatic",
            group: "Quality",
            order: 6,
            actions: ["view", "create", "edit", "delete"],
            apiPaths: [
                "/programmatic",
                "/programmatic/*",
                "/api/v1/programmatic",
                "/api/v1/programmatic/*",
            ],
        },
        {
            label: "A/B Tests",
            icon: "FlaskConical",
            path: "/ab-tests",
            group: "Quality",
            order: 7,
            actions: ["view", "create", "edit", "delete"],
            apiPaths: ["/ab-tests", "/ab-tests/*", "/api/v1/ab-tests", "/api/v1/ab-tests/*"],
        },
        {
            label: "Audit Log",
            icon: "ScrollText",
            path: "/audit-log",
            group: "Quality",
            order: 8,
            actions: ["view"],
            apiPaths: ["/api/v1/audit-log", "/api/v1/audit-log/*"],
        },
    ],
    routes: [
        {
            path: "/ab-tests",
            component: lazy(() => import("./pages/ABTests.js").then((m) => ({ default: m.ABTests }))),
        },
        {
            path: "/ab-tests/new",
            component: lazy(() => import("./pages/ABTestDetail.js").then((m) => ({ default: m.ABTestDetail }))),
        },
        {
            path: "/ab-tests/:id",
            component: lazy(() => import("./pages/ABTestDetail.js").then((m) => ({ default: m.ABTestDetail }))),
        },
        {
            path: "/audit-log",
            component: lazy(() => import("./pages/AuditLog.js").then((m) => ({ default: m.AuditLog }))),
        },
        {
            path: "/programmatic",
            component: lazy(() => import("./pages/Programmatic.js").then((m) => ({ default: m.Programmatic }))),
        },
    ],
};
//# sourceMappingURL=index.js.map